import { Controller } from "@hotwired/stimulus"

// Mobile dropdown toggle for nested navigation
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    const isHidden = this.contentTarget.classList.toggle("hidden")

    if (this.hasIconTarget) {
      this.iconTarget.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)'
    }
  }
}
